import Settings from "../../../constants/Settings";
import ApiHelper from "../../../shared/ApiHelper";
import { IObservationServiceObj } from "../../../shared/apiServices/IApiInterfaces";

export interface IWildLifeServiceObj {
    id: number,
    name: string
} 
export interface IObservationPhotoUploadResp {
    imageUrl: string,
    imageName: string
} 

const ObservationsFormApiHelpers = {
    getAllWildlife: async (): Promise<IWildLifeServiceObj[]> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/wildlife`, true)).data;
    },
    putEditedObservation: async (request: IObservationServiceObj): Promise<IObservationServiceObj> => {
        return (await ApiHelper.put(`${Settings.HabitatUrl}/observations/${request.id}`, true, request)).data;
    },
    postNewObservation: async (request: IObservationServiceObj): Promise<number> => {
        return (await ApiHelper.post(`${Settings.HabitatUrl}/observations`, true, request)).data;
    },
    uploadObservationPhoto: async (observationId: number, photo: File): Promise<IObservationPhotoUploadResp> => {
        const formData = new FormData();
        formData.append('image', photo);
        return (await ApiHelper.post(`${Settings.HabitatUrl}/observations/${observationId}/uploadImage`, true, formData, undefined, 'multipart/form-data')).data;
    },
    getObservationImage: async (observationId: number, imageName: string): Promise<any> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/observations/${observationId}/image?image=${imageName}`, true)).data;
    },
};

export default ObservationsFormApiHelpers